var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyhound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-293 389 24 16",
    style: {
      enableBackground: "new -293 389 24 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E89780;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AFF521B7-8A1C-4CE8-AA6F-0E4A52C6762F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-118.000000, -646.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_0",
    transform: "translate(83.000000, 626.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Greyhounds",
    transform: "translate(35.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-269,391.3c-0.3,0.4-0.5,0.6-0.9,0.7s0,0.2-0.7,0.1c-0.6-0.1-1.5-0.4-2,0.2c-0.5,0.6-0.9,1-0.7,1.7 c0.1,0.7,0.3,1,0.1,1.6c-0.2,0.7-0.2,0.8-0.6,1.6c-0.4,0.7-0.5,1.7-0.6,2.2c0,0.5-0.4,2.8-0.5,3.5c0,0.8,0.4,1.2,0.6,1.3 c0.2,0,0.6,0,0.7,0.2c0,0,0.3,0.2,0.3,0.5h-2c0-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.4-1.3-0.6-1.6c-0.1-0.1-0.2-2.5-0.2-2.9 c0-0.4-0.3-1-0.4-1.3c-0.2,0.2-3.2-0.5-3.9-0.9c-0.7-0.4-1.3-0.8-2.1-1.1c-0.3-0.1-1.5-0.6-1.8-0.3c0,0,0.3,0.2,0,0.5 c-0.3,0.2-0.9-0.1-0.9-0.1s0.7,0.5-0.3,1.9c-1,1.5-1.8,2.3-1.9,3.7c-0.1,1.4,0.3,1.5,0.5,1.5c0.2,0.1,0.8,0.2,0.7,0.7 c0,0,0,0-0.1,0.1h-1.2c-0.2-0.1-0.4-0.3-0.6-0.3c-0.1-0.1-0.3-2.4-0.3-2.9c0-0.5,0.1-1,0.2-1.1c0.1-0.2,0.4-1.3,0.4-1.6 c0,0.1-0.9,1.4-1.7,2c-0.8,0.6-1,0.7-1.2,1.4c-0.2,0.7-0.4,1.7-0.4,1.7s0.8,0.1,0.8,0.5c0,0.4-0.5,0.2-0.7,0.2 c-0.2,0-0.7,0-0.7,0s-0.1-0.4-0.3-0.4c0,0,0.1-2,0.5-2.8c0,0-1.2,1.3-1.4,1.2c-0.2-0.1,0.2-0.7,1.1-1.5 c0.9-0.8,1.8-2.1,1.8-2.6s-0.4-3.4,1-4.6c3.5-3.2,11.7-1,12.5-2c0.8-0.9,2.7-2.9,3-2.8c0.1,0,0.3-0.3,1-0.3 c0.7,0,1.2,0.2,1.2,0.4c0,0,0.2,0.1,0.2,0.3c0,0.2,0.4,0.3,0.4,0.4C-270.7,390.2-268.8,391-269,391.3"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyhound);
export default __webpack_public_path__ + "static/media/Greyhound.20b7730e4ad902363a947bdb05961342.svg";
export { ForwardRef as ReactComponent };